import React from "react";
import { Route } from "react-router-dom";

import { setTitleAndFaviconForAurora } from "helpers";

export const PublicRoute = ({
	component: Component,
	pageName,
	path,
	...rest
}) => {
	return (
		<Route
			{...rest}
			path={path}
			render={props => {
				setTitleAndFaviconForAurora(pageName);
				return <Component {...props} />;
			}}
		/>
	);
};
